import { styled } from '@ltvco/refresh-lib/theme';

export const StyledImage: React.ComponentType<
  React.ImgHTMLAttributes<HTMLImageElement> & {
    objectFit?: React.CSSProperties['objectFit'];
  }
> = styled('img')<{ objectFit?: React.CSSProperties['objectFit'] }>(
  ({ objectFit }) => ({
    width: '104px',
    height: '64px',
    objectFit: objectFit || 'fill',
  }),
);
